import { render, staticRenderFns } from "./index.vue?vue&type=template&id=386c8e7f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./scss.scss?vue&type=style&index=0&id=386c8e7f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c8e7f",
  null
  
)

export default component.exports